import { getLeadsFilter, setLeadsFilter } from 'store/leads';
import { LeadsFilter, LeadStatus } from 'types/leads';
import { Dictionary } from 'utils/constants/dictionary';
import { useAppDispatch, useAppSelector } from 'utils/hooks';
import LeadStatusDropdown from 'views/leads/lead-status-dropdown';

const getHighlightedBtns = (filter: LeadsFilter): LeadStatus[] => {
	const res: LeadStatus[] = [];

	if (filter.contactedStatus) res.push(LeadStatus.CONTACTED);
	if (filter.inNegotiationsStatus) res.push(LeadStatus.IN_NEGOTIATIONS);
	if (filter.linkSentStatus) res.push(LeadStatus.LINK_SENT);
	if (filter.lostStatus) res.push(LeadStatus.LOST);
	if (filter.newLeadStatus) res.push(LeadStatus.NEW_LEAD);
	if (filter.postponedStatus) res.push(LeadStatus.POSTPONED);
	if (filter.soldStatus) res.push(LeadStatus.SOLD);

	return res;
};

const LeadStatusMultipleSelect = (): JSX.Element =>{
	const dispatch = useAppDispatch();

	const filter: LeadsFilter = useAppSelector(getLeadsFilter);

	const updateFilter = (filterKey: keyof LeadsFilter): void => {
		dispatch(setLeadsFilter({ ...filter, [filterKey]: !filter[filterKey] }));
	};

	const handleSelect = (status: LeadStatus) => {
		switch (status) {
			case LeadStatus.CONTACTED: {
				updateFilter('contactedStatus');
				break;
			}
			case LeadStatus.IN_NEGOTIATIONS: {
				updateFilter('inNegotiationsStatus');
				break;
			}
			case LeadStatus.LINK_SENT: {
				updateFilter('linkSentStatus');
				break;
			}
			case LeadStatus.LOST: {
				updateFilter('lostStatus');
				break;
			}
			case LeadStatus.NEW_LEAD: {
				updateFilter('newLeadStatus');
				break;
			}
			case LeadStatus.POSTPONED: {
				updateFilter('postponedStatus');
				break;
			}
			case LeadStatus.SOLD: {
				updateFilter('soldStatus');
				break;
			}
			default: break;
		}
	};

	return (
		<LeadStatusDropdown
			btnDefaultText="Status"
			btnTextId={Dictionary.leads.statusPlaceholder}
			closeOnSelect={false}
			highlightedBtns={getHighlightedBtns(filter)}
			onSelect={handleSelect}
		/>
	);
};

export default LeadStatusMultipleSelect;
